<template>
  <div class="py-md-5 py-4">
    <div class="text-center mb-5">
      <h3 class="text-primary">Welcome Back !</h3>
      <p class="text-muted">Sign in to continue to NEW ABC APP.</p>
    </div>
    <form>
      <div class="form-floating mb-3">
        <input
          type="text"
          class="form-control"
          id="signby"
          v-model="singinby"
          placeholder="Joud"
          required
        />
        <label for="signby" class="form-label">Username</label>
        <div class="form-text">Username must be in lowercase letters only</div>
      </div>

      <div class="mb-3">
        <div class="d-flex justify-content-end">
          <router-link
            :to="{ name: 'ForgotPassword' }"
            custom
            v-slot="{ navigate }"
          >
            <a
              role="link"
              @click="navigate"
              class="pe-0 text-decoration-none text-primary"
              @keypress.enter="navigate"
            >
              Forgot password?
            </a>
          </router-link>
        </div>
        <div class="form-floating position-relative auth-pass-inputgroup mb-3">
          <input
            type="password"
            class="form-control pe-5"
            placeholder="Enter Password"
            id="password"
            v-model="password"
            required
          />
          <label for="password" class="form-label">Password</label>
          <button
            class="btn mt-2 btn-link position-absolute end-0 top-0 text-decoration-none"
            type="button"
            @click="$store.state.utils.switTypeInput"
          >
            <i class="ri-eye-fill align-middle"></i>
          </button>
        </div>
        <div class="form-text font-size-12 mx-1 row">
          <div
            :class="
              has_lowercsae
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one lowercase letter"
          ></div>
          <div
            :class="
              has_uppercase
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one uppercase letter"
          ></div>
          <div
            :class="
              has_number
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one Number"
          ></div>
          <div
            :class="
              has_minimum_lenth
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least 8 chacters"
          ></div>
          <div
            :class="
              has_special
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one special character"
          ></div>
        </div>
      </div>

      <div class="text-center mt-4">
        <button
          v-if="nameIsCorrect && passwordIsCorrect"
          @click="submit"
          type="submit"
          class="btn btn-primary w-100"
        >
          Sign In
        </button>

        <button
          v-else
          type="submit"
          class="btn btn-primary w-100 disabled"
          disabled
        >
          Sign In
        </button>
      </div>
    </form>
    <!-- end form -->

    <div class="mt-5 text-center text-muted">
      <p>
        Don't have an account ?

        <router-link :to="{ name: 'Signup' }" custom v-slot="{ navigate }">
          <a
            role="link"
            @click="navigate"
            class="fw-medium text-decoration-underline"
            @keypress.enter="navigate"
          >
            Register
          </a>
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignIn",
  data() {
    return {
      singinby: "",
      password: "",
      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,

      passwordIsCorrect: false,
      nameIsCorrect: false,
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },

  watch: {
    password() {
      const val = this.$store.state.utils.filters.password(this.password);

      this.has_minimum_lenth = val.has_minimum_lenth;
      this.has_number = val.has_number;
      this.has_lowercsae = val.has_lowercsae;
      this.has_uppercase = val.has_uppercase;
      this.has_special = val.has_special;

      this.passwordIsCorrect =
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth;
    },

    singinby() {
      const val = this.$store.state.utils.filters.name(this.singinby);

      this.nameIsCorrect =
        val.has_minimum_lenth && val.only_letters && val.is_mail;
    },
  },

  methods: {
    submit() {
      event.preventDefault();
      if (this.nameIsCorrect && this.passwordIsCorrect) {
        const data = {
          singinby: this.singinby,
          password: this.password,
        };
        this.$store.state.modules.api
          .singIn(data)
          .then((resp) => {
            this.singinby = "";
            this.password = "";
            if (resp.status === 200) {
              this.$store.state.modules.account.user = resp.data.user;
              this.$store.state.modules.account.token = resp.data.token;

              this.$router.push({ name: "Home" });
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  message: "Check the entries are correct",
                },
                2500
              );
            }
          })
          .catch((e) => {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "There is something missed!",
              },
              2500
            );
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "Check the entries are correct",
          },
          2500
        );
      }
    },
  },
};
</script>

<style>
.has_required {
  text-decoration: line-through;
  color: #f18554;
}
</style>
